import React, { Component } from 'react';
import i18n from 'utils/translate';
import Address from '../Address';
import Languages from '../Languages';
import AdditionalInRegion from '../AdditionalInRegion';

const defaultProps = {
  advisor: null,
  onCommunityClick: () => {},
  onRegionClick: () => {}
};

class Advisor extends Component {
  render() {
    const { advisor } = this.props;
    let advisorTitle;
    if (advisor.title) {
      advisorTitle = '| ' + advisor.title;
    }
    let customAddressHeadline = advisor.address.private ? i18n('privat-address') : i18n('office-address');
    return (
      <article className="office__person col-xs-12">
        <div className="office__person-top">
          <div className="row row-no-gutters">
            <div className="col">
              <div
                className="office__person-image"
                data-responsive-background-image
                style={{ backgroundImage: `url(${advisor.image ? advisor.image : ''})` }}
              >
                <img src={advisor.image} className="img-responsive" alt={`${advisor.name} ${advisor.lastname}`} />
              </div>
              <div>
                <div className="office__person-name">
                  {advisor.name} {advisor.lastname} {advisorTitle}
                </div>
                <div className="office__person-function">{advisor.jobTitle}</div>
                <div className="office__person-office">
                  <a href={advisor.office.detailUrl}>
                    {i18n('office')} {advisor.office.name}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Address
              contacts={advisor.contacts}
              address={advisor.address}
              lat={advisor.lat}
              lon={advisor.lon}
              customHeadline={customAddressHeadline}
            ></Address>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-xs-12">
            <Languages languages={advisor.languages} headline={i18n('languages-person')}></Languages>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <AdditionalInRegion
              region={advisor.address}
              onCommunityClick={this.props.onCommunityClick}
              onRegionClick={this.props.onRegionClick}
              headline={i18n('other-advisors')}
            ></AdditionalInRegion>
          </div>
        </div>
      </article>
    );
  }
}

Advisor.defaultProps = defaultProps;

export default Advisor;
